import useAppStore from "@/context/store";
import { searchTopic } from "@/services";
import { isString } from "lodash";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";
import MaterialCollectionCard from "../MaterialCollection/card";
import styles from "./index.module.less";
export default function TopicSimilarList({ keyword, serverSideSimilarTopics }) {
  const router = useRouter();
  const { urlname } = router.query;
  const [dataSource, setDataSource] = useState(serverSideSimilarTopics || []);
  const column = useAppStore(({ column }) => column);

  const queryAction = useCallback(async () => {
    if (!keyword) {
      return;
    }

    const result = await searchTopic({
      q: keyword,
      per_page: 25,
      page: 1,
      exclude_topic: isString(urlname)
        ? urlname.replace(/^topic-/, "")
        : urlname,
      dedupe: 1,
    });

    setDataSource(
      result?.result?.filter((record) => record?.pin_count > 0) || []
    );
  }, [keyword, urlname]);

  useEffect(() => {
    if (!serverSideSimilarTopics?.length) {
      queryAction();
    }
  }, [queryAction, serverSideSimilarTopics]);

  const columnSize = useAppStore(({ columnSize }) => columnSize);

  if (dataSource.length <= 0) {
    return null;
  }

  return (
    <div className={styles.section}>
      <div className={styles.title}>相关主题推荐</div>
      <div className={styles.list}>
        {dataSource.map((record, index) => {
          const { content_title, title } = record;
          let realTitle =
            title && content_title !== title
              ? `${content_title}/${title}`
              : content_title;
          return (
            <MaterialCollectionCard
              key={record.id}
              style={{
                ...((index + 1) % column !== 0
                  ? { marginRight: "16px" }
                  : { marginRight: "0" }),
                width: columnSize,
              }}
              className={styles.item}
              pins={record.pins}
              topicId={record.urlname}
              pinCount={record.pin_count}
              filter={{ title: realTitle, value: record.filter_id }}
              title={record.title}
            />
          );
        })}
      </div>
    </div>
  );
}
